import React from "react";
import { Link } from "@/components/common/Link";
import { ArrowRight, Dog, Cat, Rabbit } from "lucide-react";
const speciesCategories = [{
  id: "sires",
  name: "Our Sires",
  href: "/OurCavaliersPage#DistinguishedSires",
  image: "https://cobrnik.com/wp-content/uploads/2026/04/Rocket-wind-blown-1.jpg?v=dfa5eur6h9",
  icon: Dog,
  description: "Distinguished gentlemen of the breed",
  imageClassName: "absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-60 group-hover:opacity-40 transition-opacity duration-500 z-10 !bg-[url(https://cobrnik.com/wp-content/uploads/2026/04/Rocket-wind-blown.jpg)]"
}, {
  id: "dams",
  name: "Our Dams",
  href: "/OurCavaliersPage#TheMasterBarbers",
  image: "https://brave-rhino.10web.cloud/wp-content/uploads/2026/04/Screenshot-2022-10-20-at-3.26.52-PM.png",
  icon: Cat,
  description: "Elegant matriarchs of our lineage",
  imageClassName: "bg-cover bg-center"
}, {
  id: "upcoming",
  name: "Upcoming",
  href: "/Puppies",
  image: "https://cobrnik.com/wp-content/uploads/2026/04/Blenheims-in-a-basket-scaled.jpg?v=4pxer0w9fcl",
  icon: Rabbit,
  description: "Future champions and planned litters",
  imageClassName: "bg-cover bg-center"
}, {
  id: "retired",
  name: "Retired",
  href: "/OurCavaliersPage#Projects",
  image: "https://cobrnik.com/wp-content/uploads/2026/06/Sully-head-shot-scaled.jpeg?v=tphriepq5rf",
  icon: Dog,
  description: "Our beloved veterans in their golden years",
  imageClassName: "bg-cover bg-center"
}];
export default function ShopBySpecies() {
  return <section data-section-id="63268" id="our-breed-categories" className="bg-background py-16 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-serif font-light text-foreground mb-4 tracking-tight">
            Our Breed Categories
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans">
            Explore the distinguished heritage and future of Cobrnik Cavaliers. Select a category to learn more about our regal companions.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {speciesCategories.map((category, i) => <Link key={category.id} to={category.href} data-index={i} className="group relative flex flex-col items-center text-center">
              <div className="relative w-full aspect-square max-w-[280px] mb-6 rounded-xl overflow-hidden border border-secondary group-hover:border-primary transition-all duration-500 shadow-sm group-hover:shadow-xl bg-muted">
                
                
                <img src={category.image} alt={category.name} className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-700 ease-out" />

                <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm p-2 rounded-lg shadow-sm z-20 opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300">
                  <ArrowRight className="w-5 h-5 text-black" />
                </div>
              </div>

              <h3 className="text-2xl font-serif text-foreground group-hover:text-primary transition-colors duration-300 flex items-center gap-2">
                {category.name}
              </h3>
              <p className="text-muted-foreground mt-2 text-sm font-sans uppercase tracking-widest">
                {category.description}
              </p>
            </Link>)}
        </div>
      </div>
    </section>;
}